import HBIcon from "@/components/HBIcon";
import { TrackerA } from "@/components/Tracker";
import useAppStore from "@/context/store";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useLogin } from "../LoginModal";
import styles from "./NavItem.module.less";

export default function NavItem({
  icon,
  title,
  link,
  openInNewTab,
  isCollapsed,
  onClick,
  loginRequired,
  customActiveCheck,
  id,
  extraElement,
  index,
}) {
  const router = useRouter();
  const user = useAppStore((state) => state.user);
  const { login } = useLogin();

  const isActive = () => {
    if (customActiveCheck) {
      return customActiveCheck(router.pathname);
    }
    return router.asPath.startsWith(link);
  };

  const handleClick = async (e) => {
    if (loginRequired && !user) {
      e.preventDefault();
      await login();
    }

    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Link href={link || "#"} passHref>
      <TrackerA
        id={id}
        className={classNames(styles.navItem, {
          [styles.active]: isActive(),
          [styles.collapsed]: isCollapsed,
        })}
        target={openInNewTab ? "_blank" : undefined}
        onClick={handleClick}
        data-tooltip={
          isCollapsed ? (openInNewTab ? title + " ↗" : title) : null
        }
        data-gd-expose="resource_loc_expose"
        data-gd-click="resource_loc_click"
        data-tooltip-position="right"
        data-module-name="左侧导航栏"
        data-subject-name="资源位"
        data-apply-client="使用端"
        data-resource-title={title}
        data-resource-location={index + 1}
      >
        <HBIcon type={icon} className={styles.icon} />
        {!isCollapsed && (
          <>
            <span className={styles.title}>{title}</span>
            {extraElement && (
              <span className={styles.extra}>{extraElement}</span>
            )}
            {!extraElement && openInNewTab && (
              <HBIcon type="ic_open" className={styles.linkIcon} />
            )}
          </>
        )}
      </TrackerA>
    </Link>
  );
}
